import padStart from 'lodash/padStart';

interface IMaskFunction {
  apply(value: string | number): string;
  clean(value: string): string | number;
}

export const phone = (value: string) => {
  if (!value) return '';

  const regexp = value.length > 10 ? /^(\d{0,2})(\d{0,5})(\d{0,4}).*/ : /^(\d{0,2})(\d{0,4})(\d{0,4}).*/;

  const result = value.length > 2 ? '($1) $2-$3' : '($1$2$3';

  return value.replace(regexp, result).replace(/-$/, '');
};

export const zipcode = (value: string) => {
  if (!value) return '';
  return String(value).replace(/^(\d{0,5})(\d{0,3}).*/, '$1-$2').replace(/-$/, '');
};

export const decimal: IMaskFunction = {
  apply: (value: number | string) => {
    if (value === null || value === undefined || value === '') return '';
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Number(value) || 0);
  },
  clean: value => {
    value = (value || '').toString().replace(/[^\d,]/gi, '');

    if (!value.includes(',')) {
      value = '0,' + padStart(value, 2, '0');
    }

    const [, cents] = value.split(',');
    if (cents && cents.length !== 2) {
      value = value.replace(',', '').replace(/(\d+)?(\d{2})/gi, '$1,$2').replace(/^,/gi, '0,');
    }

    return value.replace(/\./gi, '').replace(',', '.');
  }
};

export const cnpj = {
  apply(value: string) {
    if (!value) return '';
    const regexp = /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2}).*/;
    const result = '$1.$2.$3/$4-$5';
    return String(value)
      .replace(regexp, result)
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '');
  },
  clean: (value: string) => value.replace(/\D/gi, '').substr(0, 14)
};

export const cpf = (value: string) => {
  if (!value) return '';
  const regexp = /^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*/;
  const result = '$1.$2.$3-$4';
  return value
    .replace(regexp, result)
    .replace(/[-.\\]$/, '')
    .replace(/[-.\\]$/, '')
    .replace(/[-.\\]$/, '');
};

export const document = (value: string) => {
  if (!value) return '';
  return value.length > 11 ? cnpj.apply(value) : cpf(value);
};
